import en from "./locales/en";
import no from "./locales/no";
import de from "./locales/de";
import fr from "./locales/fr";
import es from "./locales/es";
import nl from "./locales/nl";
import zh from "./locales/zh";
import th from "./locales/th";

export const translations = { en, no, de, fr, es, nl, zh, th };

export const LANGUAGES = [
  { code: "no", label: "Norsk", short: "NO" },
  { code: "en", label: "English", short: "EN" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "es", label: "Español", short: "ES" },
  { code: "nl", label: "Nederlands", short: "NL" },
  { code: "zh", label: "中文", short: "ZH" },
  { code: "th", label: "ไทย", short: "TH" },
];
